module.exports = __webpack_public_path__ + "img/mb_header_bg2.b0c827f.webp";